import { AppPlans } from '@app/core/enums/app-plans.enum';
import { PaywallPlan } from '@app/core/services/infrastructure/analytics/analytics.service';

/** A subscription offered on the paywall. Texts are translation keys under `paywall.plans.<id>`. */
export interface IPaywallPlan {
    id: PaywallPlan;
    /** Plan sent to the existing Stripe checkout. */
    plan: AppPlans;
    /** Amount charged per billing period in EUR, reported with `begin_checkout`. */
    value: number;
    /** Shown as a badge next to the title. */
    hasBadge: boolean;
    features: string[];
}

export const PAYWALL_CONSTANTS = {
    /** `?source=` on `/upgrade`; anything else (mails, ads) is passed through when it looks like a source name. */
    SOURCES: {
        /** A coach without free sessions left wants to prompt again. */
        CREDITS_EXHAUSTED: 'credits_exhausted',
        /** Shortly after the coach created their last free session (see `PaywallService`). */
        TRIAL_END: 'trial_end',
        DIRECT_LINK: 'direct_link',
        /** The coach moved the mouse towards closing the tab (see `ExitIntentService`). */
        EXIT_INTENT: 'exit_intent',
        /** "Explore plans" in the sidekick's speech bubble. */
        SIDEKICK: 'sidekick',
    },
    SOURCE_PATTERN: /^[a-z0-9_]{1,40}$/,

    /** How often the paywall may open by itself per coach, by source. Others are unlimited. */
    LIMITS_PER_COACH: {
        exit_intent: 1,
    } as Record<string, number>,

    /** After the last free session, the paywall opens this much later (time to look at the session). */
    TRIAL_END_DELAY_MS: 10_000,

    DEFAULT_PLAN: 'year' as PaywallPlan,

    PLANS: [
        {
            id: 'year',
            plan: AppPlans.Standard_Yearly,
            value: 90,
            hasBadge: true,
            features: ['paywall.plans.year.features.0', 'paywall.plans.year.features.1', 'paywall.plans.year.features.2'],
        },
        {
            id: 'month',
            plan: AppPlans.Standard,
            value: 9,
            hasBadge: false,
            features: ['paywall.plans.month.features.0', 'paywall.plans.month.features.1', 'paywall.plans.month.features.2'],
        },
    ] as IPaywallPlan[],
} as const;
